// React & Redux
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Helpers, Actions, & Reducers
import { history } from '_helpers';
import { alertActions, smoothieActions, userActions } from '_actions';

// Router
import { Switch, Router, Redirect, Route } from 'react-router-dom';
import { PrivateRoute, Navigation, Footer, ScrollToTop, Routes } from '_components';

// Routes
import { ThankyouPage } from 'views/ThankyouPage';
// import { AdminPage } from 'views/AdminPage';
// import { HomePage } from 'views/HomePage';
// import { AboutPage } from 'views/AboutPage';
// import { SmoothiesPage } from 'views/SmoothiesPage';
// import { OrderPage } from 'views/OrderPage';
// import { SettingsPage } from 'views/SettingsPage';
// import { LoginPage } from 'views/LoginPage';
// import { RegisterPage } from 'views/RegisterPage';
// import { ForgotPasswordPage } from 'views/ForgotPasswordPage';
// import { SetPasswordPage } from 'views/SetPasswordPage';
// import { ActivatePage } from 'views/ActivatePage';
// import { TermsPage } from 'views/TermsPage';

// styled-components global & theme stuff
import { injectGlobal, ThemeProvider as StyledThemeProvider } from 'styled-components';
import styles from 'styles/styles';

// HMR
import { hot } from 'react-hot-loader';

// Components
import { AppAlert, Layout } from 'sc-ui';

// Helpers
import _ from 'lodash';

// eslint-disable-next-line
injectGlobal`
    body {
        font-family: 'Source Sans Pro', 'Open Sans';
        width: 100%;
        max-width: 100%;
        min-height: 100vh;
        margin: 0;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        /* background: #f6f7f4; */
        background: #fffffe;
        /* background-image: linear-gradient(${`to bottom right, ${
            styles.color.scLightGray4
        }, white`}); */
        color: ${styles.color.scDarkGray2};
    }
    a {
        color: ${styles.color.scDarkGray2};
    }
`;

class App extends React.Component {
    // componentDidMount() {
    //     // get own user
    //     if (localStorage.getItem('user')) {
    //         this.props.getOwnUser();
    //     }
    //     // grab all active smoothies
    //     this.props.getActiveSmoothies();
    //     history.listen((location, action) => {
    //         // clear alert on location change
    //         this.props.clearAlerts();
    //     });
    // }

    render() {
        const { alert } = this.props;
        return (
            <Router history={history}>
                <ScrollToTop>
                    <React.Fragment>
                        <Layout.Base color="#fffffe">
                            <Layout.Base>
                                {_.get(alert, ['message']) && AppAlert(alert)}
                                <Switch>
                                    {/* <Routes.Admin path="/admin" component={AdminPage} />
                                    <Route exact path="/home" component={HomePage} />
                                    <Route exact path="/about" component={AboutPage} />
                                    <Route exact path="/smoothies" component={SmoothiesPage} />
                                    <Route exact path="/login" component={LoginPage} />
                                    <Route exact path="/register" component={RegisterPage} />
                                    <Route exact path="/forgotPassword" component={ForgotPasswordPage} />
                                    <Route exact path="/terms" component={TermsPage} />
                                    <Route path="/setPassword" component={SetPasswordPage} />
                                    <Route path="/activate/:verify_token" component={ActivatePage} />
                                    <PrivateRoute exact path="/order" component={OrderPage} />
                                    <PrivateRoute path="/settings" component={SettingsPage} />
                                    <Redirect to="/home" /> */}
                                    <Route exact path="/thankyou" component={ThankyouPage} />
                                    <Redirect to="/thankyou" />
                                </Switch>
                            </Layout.Base>
                        </Layout.Base>
                        <Footer />
                    </React.Fragment>
                </ScrollToTop>
            </Router>
        );
    }
}
// const mapStateToProps = (state) => {
//     const { alert } = state;
//     return { alert };
// };

// export default hot(module)(connect(mapStateToProps)(App));

function mapStateToProps(state) {
    const { alert } = state;
    const { loading, user } = state.users;
    return {
        loading,
        user,
        alert
    };
}
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getOwnUser: userActions.getOwn,
            getActiveSmoothies: smoothieActions.getActive,
            clearAlerts: alertActions.clear
        },
        dispatch
    );

const connectedApp = hot(module)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(App)
);
export { connectedApp as App };



// WEBPACK FOOTER //
// ./src/App.jsx